import { Injectable } from '@angular/core';

@Injectable()
export class LogService {
  constructor() { }

  debug(msg: any) {
    console.debug(new Date() + ": "
                + JSON.stringify(msg));
  }

  log(msg: any) {
    console.log(new Date() + ": "
                + JSON.stringify(msg));
  }

  error(msg: any) {
    console.error(new Date() + ": "
                + JSON.stringify(msg));
  }

  warn(msg: any) {
    console.warn(new Date() + ": "
                + JSON.stringify(msg));
  }

}
